var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCompliant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.014,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#60c9b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_1974",
    x: 0,
    y: 0,
    width: 74,
    height: 74,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "compliant",
    transform: "translate(-173 -4521)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 173, 4521)",
    filter: "url(#Path_1974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1974-2",
    "data-name": "Path 1974",
    d: "M28,0A28,28,0,1,1,0,28,28,28,0,0,1,28,0Z",
    transform: "translate(9 6)",
    opacity: 0,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Safe_and_secure_transactions",
    "data-name": "Safe and secure transactions",
    transform: "translate(185 4529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M0,0H48V47H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Safe_and_secure_transactions-2",
    "data-name": "Safe and secure transactions"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6-2",
    "data-name": "Path 6",
    d: "M0,0H48V47H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    d: "M43.734-34.148l-18-7.5A4.416,4.416,0,0,0,24.006-42a4.415,4.415,0,0,0-1.728.352l-18,7.5A4.494,4.494,0,0,0,1.5-30C1.5-5.864,19.259,6,23.994,6,28.612,6,46.5-5.685,46.5-30A4.5,4.5,0,0,0,43.734-34.148ZM24,1.5C14.859-2.309,6-14.133,6-30l18-7.5L42-30C42-13.711,32.777-2.156,24,1.5ZM18.841-18.842A2.243,2.243,0,0,0,17.25-19.5,2.25,2.25,0,0,0,15-17.251a2.243,2.243,0,0,0,.659,1.591l4.5,4.5a2.253,2.253,0,0,0,1.591.659,2.265,2.265,0,0,0,1.708-.785l9-10.5A2.242,2.242,0,0,0,33-23.25a2.264,2.264,0,0,0-2.248-2.25,2.249,2.249,0,0,0-1.71.784l-7.418,8.657Z",
    transform: "translate(2 46)",
    fill: "#2f6fb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    d: "M43.734-34.148l-18-7.5A4.416,4.416,0,0,0,24.006-42a4.415,4.415,0,0,0-1.728.352l-18,7.5A4.494,4.494,0,0,0,1.5-30C1.5-5.864,19.259,6,23.994,6,28.612,6,46.5-5.685,46.5-30A4.5,4.5,0,0,0,43.734-34.148ZM24,1.5C14.859-2.309,6-14.133,6-30l18-7.5L42-30C42-13.711,32.777-2.156,24,1.5ZM18.841-18.842A2.243,2.243,0,0,0,17.25-19.5,2.25,2.25,0,0,0,15-17.251a2.243,2.243,0,0,0,.659,1.591l4.5,4.5a2.253,2.253,0,0,0,1.591.659,2.265,2.265,0,0,0,1.708-.785l9-10.5A2.242,2.242,0,0,0,33-23.25a2.264,2.264,0,0,0-2.248-2.25,2.249,2.249,0,0,0-1.71.784l-7.418,8.657Z",
    transform: "translate(0 44)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompliant);
export default __webpack_public_path__ + "static/media/compliant.804c5db9091dd091d3eb9acc9b91d558.svg";
export { ForwardRef as ReactComponent };